// Generated by `yarn tokens:import --aos-ds` from the Figma component set "Filter" (6868:70896). Do not edit.
//
// The "state" axis is interaction state, so it is not a prop: hover and hovered are `hover:`, pressed is `active:`, focus is `focus:`,
// and disabled is applied in JS because react-native-web renders a div, which
// Tailwind's `disabled:` never matches.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

// A place the Figma file contradicts itself, grouped by what it says. `count` is
// how many places say it; `property` and `stated` are set for an alignment the
// file states and does not draw.
export type ContractDisagreement = {
    note: string
    count: number
    property?: string
    stated?: string
}

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const filterContract = {
    component: 'Filter',
    nodeId: '6868:70896',
    section: '[Web] Primitives',
    // Components a variant instantiates, with the variant keys used.
    // Where one of these carries the component's own paint rather than
    // a glyph, the classes below describe only what is left — Checkbox
    // swaps a whole box here.
    composes: [
        { component: 'ChevronDown', variants: [] },
        { component: 'ChevronUp', variants: [] },
    ],
    stateAxis: 'state',
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: [] as readonly string[],
    // What the file says that its own drawing does not show.
    disagreeing: [] as readonly ContractDisagreement[],
    textStyleIds: ['S:0fa036ddc0a173a340137517ff39c483dfbade3d,'],
    props: {
        selection: { kind: 'enum', values: ['not-selected', 'selected'] },
        type: { kind: 'enum', values: ['pill', 'dropdown-closed', 'dropdown-open'] },
    },
    variants: {
        'selection=not-selected, type=pill': {
            container:
                'rounded-badge-round px-s py-2xs gap-2xs h-[1.75rem] min-h-[1.75rem] items-center hover:bg-background-surface-hover hover:border-border-strong hover:border',
            label: 'text-content-muted text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                Current: 'text-content-muted text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                Current: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [],
        },
        'selection=selected, type=dropdown-closed': {
            container:
                'bg-background-surface border-border-strong border rounded-badge-round pl-s pr-xs py-2xs gap-2xs h-[1.75rem] min-h-[1.75rem] items-center hover:bg-background-surface-hover',
            label: 'text-content-default text-left',
            icon: 'text-content-default',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                Current: 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                Current: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [{ component: 'ChevronDown', variants: [] }],
        },
        'selection=selected, type=dropdown-open': {
            container:
                'bg-background-surface border-border-strong border rounded-badge-round pl-s pr-xs py-2xs gap-2xs h-[1.75rem] min-h-[1.75rem] items-center hover:bg-background-surface-hover',
            label: 'text-content-default text-left',
            icon: 'text-content-default',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                Current: 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                Current: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [{ component: 'ChevronUp', variants: [] }],
        },
        'selection=selected, type=pill': {
            container:
                'bg-background-surface border-border-strong border rounded-badge-round px-s py-2xs gap-2xs h-[1.75rem] min-h-[1.75rem] items-center hover:bg-background-surface-hover',
            label: 'text-content-default text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                Current: 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                Current: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    disagreeing: readonly ContractDisagreement[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
